<template>
  <v-container id="logs-print" style="max-width: 1000px">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- Neverwatch print toggle -->
    <div
      style="border-bottom: 1px solid grey"
      class="mb-4"
      v-if="$store.state.NWRole"
    >
      <h3>Current Displayed Details</h3>
      <v-radio-group v-model="currentDescription" row mandatory>
        <v-radio label="Incident" value="incident" color="secondary"></v-radio>
        <!-- <v-radio label="Agency" value="agency" color="secondary"></v-radio> -->
        <v-radio label="Web" value="web" color="secondary"></v-radio>
        <!-- <v-radio label="Press" value="press" color="secondary"></v-radio> -->
      </v-radio-group>
    </div>

    <div id="logs-print-form">
      <div class="box">
        <div class="letter-header">
          <div class="letter-col">
            <img
              class="letter_badge"
              src="../../images/gold-badge.png"
              alt="Reno nevada police Badge"
            />
          </div>
          <div class="letter-col">
            <h3 class="letter-row">Reno Police Department</h3>
            <h3 class="letter-row">
              <div style="display: inline" v-if="commonDivision">
                {{ commonDivision }} Division
              </div>
              Watch Log
            </h3>
          </div>
        </div>

        <h4 class="letter-disclaimer small-font">
          The Following information is of a confidential nature <br />
          and is not for dissemination to other departments, agencies or persons
        </h4>
        <br />

        <div
          v-for="(dgroup, dindex) in division_groups"
          :key="dindex"
          :class="{ division_group: dindex != 0 }"
        >
          <h3 class="divison-header" v-if="division_groups.length > 1">
            {{ getDivisionDisplayName(dgroup.divisionID) }}
          </h3>
          <div
            v-for="(group, index) in dgroup.logGroups"
            :key="index"
            :class="{ date_group: index != 0 }"
          >
            <h3>{{ group.date }}</h3>
            <br />
            <div
              v-for="(log, yindex) in group.logs"
              :key="yindex"
              class="log-entry"
            >
              <div class="log-col" style="margin-right: 20px">
                <strong>{{ log.time }}</strong>
              </div>
              <div class="log-col">
                <div class="log-title">
                  {{ log.districts }}:
                  <span v-if="currentDescription == 'web'"
                    >{{ log.web_title }} @ {{ log.web_location }}</span
                  >
                  <span v-else>{{ log.title }} @ {{ log.location }}</span>
                </div>
                <br />

                <!-- Neverwatch can toggle the description -->
                <div v-if="currentDescription == 'incident'">
                  <div v-html="log.description"></div>

                  <!-- partiesInvolved -->
                  <div v-for="(p, pindex) in log.partiesInvolved" :key="pindex">
                    <div style="display: inline">
                      {{ p.involvement }}:
                      {{ p.firstname }}
                      {{ p.lastname }}
                      <div style="display: inline" v-if="p.dob.length > 0">
                        ({{ p.dob }})
                      </div>
                    </div>
                    <div
                      style="display: inline"
                      v-if="p.description.length > 0"
                    >
                      {{ p.description }}
                    </div>
                  </div>
                </div>

                <!-- <div v-if="currentDescription == 'agency'">
                  <div v-html="log.nvrDescription"></div>
                </div> -->

                <div v-if="currentDescription == 'web'">
                  <div v-html="log.webDescription"></div>
                </div>

                <!-- <div v-if="currentDescription == 'press'">
                  <div v-html="log.pressDescription"></div>
                </div> -->

                <br />
                <div>
                  <span v-if="log.casenum.length > 0">
                    <strong>Case# {{ log.casenum }}</strong>
                    <br />
                  </span>
                  <span v-if="log.additionalCaseNumbers.length > 0">
                    <strong
                      >Addt'l Case# {{ log.additionalCaseNumbers }}</strong
                    >
                    <br />
                  </span>
                  <strong>Sgt. {{ log.sergeant }}</strong>
                  <br />
                  <strong>Lt. {{ log.lieutenant }}</strong>
                </div>
                <br />
                <div>
                  <small
                    style="margin-right: 20px"
                    class="small-font metadata-row"
                    >Entered: {{ log.s_createduser }}
                    {{ formatDateTime(log.s_create) }}</small
                  >
                  <small class="small-font metadata-row"
                    >Edited: {{ log.s_user }}
                    {{ formatDateTime(log.s_date) }}</small
                  >
                </div>
                <div>
                  <small class="small-font metadata-row"
                    >Printed: {{ useremail }} {{ currentDateTime }}</small
                  >
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fab-container">
      <v-fab-transition>
        <v-btn
          color="secondary black--text"
          dark
          fab
          @click="goHome()"
          class="mb-6"
        >
          <v-icon> $home </v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition>
        <v-btn
          color="secondary black--text"
          elevation="5"
          class="mb-6"
          dark
          bottom
          fab
          @click="printjs"
          :disabled="logEntryIDs.length == 0"
        >
          <v-icon>$print</v-icon>
        </v-btn>
      </v-fab-transition>
      <!-- <v-fab-transition>
        <v-btn
          color="secondary black--text"
          elevation="5"
          class="mb-6"
          dark
          bottom
          fab
          @click="print"
          :disabled="logEntryIDs.length == 0"
        >
          <v-icon>$print</v-icon>
        </v-btn>
      </v-fab-transition> -->
    </div>

    <v-overlay :value="overlay_loading">
      <v-progress-circular
        indeterminate
        :size="80"
        :width="7"
        color="secondary"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss" scoped>
.fab-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  column-gap: 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
p {
  margin-bottom: 0px !important;
}

.letter-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.letter_badge {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.letter-row {
  line-height: 1;
}

.letter-disclaimer {
  border: 1px solid;
  text-align: center;
  font-style: italic;
}
.small-font {
  font-size: 9pt;
  line-height: 1.25;
}
.log-entry {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
}
.log-col {
}
.log-title {
  font-weight: bold;
  text-decoration: underline;
}
.divison-header {
  border-bottom: 2px solid;
  margin-bottom: 20px;
}
@media only screen and (max-width: 600px) {
  .metadata-row {
    display: block;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../../mixins/bus_common";
import print from "print-js";
export default {
  name: "logs_print",
  mixins: [bus_common],
  data() {
    return {
      overlay_loading: true,
      logEntryIDs: [],
      division_groups: [],
      currentDateTime: null,
      divisionObject: null,
      currentDescription: "incident",
    };
  },
  methods: {
    print: function () {
      this.$htmlToPaper("logs-print-form");
    },
    printjs: function () {
      /* this.addHashToLocation('/my/new/path')*/
      printJS({
        printable: "logs-print-form",
        documentTitle: "RPD EverWatch",
        type: "html",
        scanStyles: false,
        css: "/logs_print.css",
        // onLoadingEnd: () => {
        //   setTimeout(() => {
        //     document.title = originalTitle;
        //   }, 250);
        // },
        // onPrintDialogClose: () => {
        //   document.title = originalTitle;
        // },
      });
    },
    addHashToLocation(params) {
      history.pushState({}, null, "/");
    },
    GenImageLink(filename) {
      let link = window.location.origin + "/Upload/" + filename;
      return link;
    },
    goHome() {
      var qry_token = this.$route.query.token;
      this.$router.push({ name: "home-logs", query: { token: qry_token } });
    },
    fixLogDataDates() {
      // Any date fields from the server must be conveted to appear in field
      // For each division group, we want to iterate over each log group then the logs
      for (let a = 0; a < this.division_groups.length; a++) {
        let divisionGroup = this.division_groups[a];

        for (let b = 0; b < divisionGroup.logGroups.length; b++) {
          let logGroup = divisionGroup.logGroups[b];
          logGroup.date = this.$moment(logGroup.date).format(
            "dddd, MMMM Do YYYY"
          );
          for (let i = 0; i < logGroup.logs.length; i++) {
            let log = logGroup.logs[i];
            log.date = this.$moment(log.date).format("YYYY-MM-DD");
            for (let j = 0; j < log.partiesInvolved.length; j++) {
              log.partiesInvolved[j].dob = this.$moment(
                log.partiesInvolved[j].dob
              ).format("MM/DD/YYYY");

              if (log.partiesInvolved[j].dob == "01/01/1900") {
                log.partiesInvolved[j].dob = "";
              }
            }
          }
        }
      }
    },
    formatDateTime(date) {
      return this.$moment(new Date(date)).format("MM/DD/YYYY HHmm");
    },

    stringToIntegerArray(inputString) {
      // Split the input string by commas to get an array of strings.
      const idStrings = inputString.split(",");

      // Initialize an empty array to store the parsed integer values.
      const idArray = [];

      // Loop through the idStrings and parse them into integers.
      for (const idString of idStrings) {
        // Use parseInt to convert the string to an integer.
        const id = parseInt(idString, 10);

        // Check if the parsing was successful and the result is a valid integer.
        if (!isNaN(id) && Number.isInteger(id)) {
          idArray.push(id);
        }
      }

      return idArray;
    },

    async getLogData() {
      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: this.logEntryIDs,
        operation: "Print",
        s_del: "f",
      };
      this.overlay_loading = true;
      await this.$axios
        .post("/api/logs/GetByListDivision", form)
        .then((response) => {
          this.division_groups = response.data;
          this.fixLogDataDates();

          // If we have only one division group, we can display a header
          // Otherwise each group will do it in-line
          if (this.division_groups.length == 1) {
            this.LookupDivisionbyID(
              this.division_groups[0].logGroups[0].logs[0]
                .logEntryID_LogDivisionID
            );
          }

          //For printing, pdf title can be changed using document title
          let doctitle = `RPD EverWatch - Report ${this.$moment(
            this.currentDateTime,
            "MM/DD/YYYY HHmm"
          ).format("YYYY-MM-DD HHmm")}`;
          document.title = doctitle;
          this.overlay_loading = false;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });
    },

    async init() {
      var logEntries = this.$route.query.logEntries;

      if (logEntries == undefined) {
        let callback = () => {
          // window.location.replace(this.$store.state.loginURL);
        };
        this.$swal({
          title: "Error!",
          text: "No valid log entries were provided, please try again.",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#283593",
          timer: 4000,
          target: "logs-print",
          didClose: callback,
        });
      } else {
        this.logEntryIDs = this.stringToIntegerArray(logEntries);
        this.getLogData();
      }

      this.currentDateTime = this.$moment().format("MM/DD/YYYY HHmm");
    },

    LookupDivisionbyID(divisionID) {
      for (let index = 0; index < this.divisions_list.length; index++) {
        const element = this.divisions_list[index];
        if (element.logDivisionID == divisionID) {
          this.divisionObject = element;
        }
      }
    },
    getDivisionDisplayName(id) {
      if (this.divisions_list != null) {
        const div = this.divisions_list.find((obj) => obj.logDivisionID == id);
        // Check if an object was found
        if (div !== undefined) {
          return div.displayName;
        } else {
          // Return null or any default value if the object is not found
          return "";
        }
      }
    },
  },
  unmounted() {
    //leaving but does not look to work :(
    let doctitle = "RPD EverWatch";
    document.title = doctitle;
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== from.path) {
      // Route is changing from the current route to something else
      let doctitle = "RPD EverWatch";
      document.title = doctitle;
      next();
    } else {
      // Route is staying the same
      next();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.user.token != "") {
        this.init();
      }
    });
  },
  computed: {
    useremail: function () {
      if (this.$store.state.user.token != "") {
        return this.$store.state.user.email;
      } else {
        return "";
      }
    },
    divisions_list() {
      if (this.$store.state.logDivisions.length > 0) {
        return this.$store.state.logDivisions;
      } else {
        return null;
      }
    },
    commonDivision() {
      if (this.divisionObject == null) {
        return null;
      } else {
        return this.divisionObject.displayName;
      }
    },
  },
  watch: {
    "$store.state.user.token": function () {
      if (this.$store.state.user.token != "") {
        this.init();
      }
    },
  },
};
</script>
